export default "__VITE_ASSET__BJzrRPHQ__";